export default __webpack_public_path__ + "static/media/spinner.f7dae506.gif";